<template>
  <a-card title="Riwayat Cuti">
    <a-card class="m-card-headline">
      <div :class="!isMobile ? 'd-flex justify-between align-item-center' : ''">
        <h3 :class="!isMobile ? 'm-remove' : ''">Sisa cuti anda sebanyak : {{data.sisa_cuti}} hari</h3>
        <a-button @click="handleCuti" v-if="getAuth.divisi[0] === 'HRD'">
          <a-icon type="edit" />Edit
        </a-button>
      </div>
    </a-card>
    <a-list itemLayout="horizontal" :dataSource="data.cuti">
      <a-list-item slot="renderItem" slot-scope="item">
        <a-list-item-meta>
          <a-card slot="description">
            <a
              v-if="item.id_cuti !== null"
              @click="handleManifest(item)"
              class="title"
            >{{item.no_cuti === "" ? 'No Cuti Belum Tercatat' : replcBr(item.no_cuti)}} | {{item.user_update}} <a-icon type="snippets" /></a>
            <span
              v-else
              class="title"
            >{{item.no_cuti === "" ? 'No Cuti Belum Tercatat' : replcBr(item.no_cuti)}} | {{item.user_update}}</span>
            <a-row class="m-top">
              <a-col :xs="24" :lg="12">
                <a-row>
                  <a-col :span="8">
                    <span class="m-text-medium">Jenis</span>
                  </a-col>
                  <a-col class="m-text-center" :span="2">
                    <span>:</span>
                  </a-col>
                  <a-col :span="14">
                    <span>{{item.jenis}}</span>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="8">
                    <span class="m-text-medium">Deskripsi</span>
                  </a-col>
                  <a-col class="m-text-center" :span="2">
                    <span>:</span>
                  </a-col>
                  <a-col :span="14">
                    <span>{{item.deskripsi}}</span>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="8">
                    <span class="m-text-medium">Jumlah Cuti</span>
                  </a-col>
                  <a-col class="m-text-center" :span="2">
                    <span>:</span>
                  </a-col>
                  <a-col :span="14">
                    <span>{{item.jumlah_cuti}}</span>
                  </a-col>
                </a-row>
              </a-col>
              <a-col :xs="24" :lg="12">
                <a-row>
                  <a-col :span="10">
                    <span class="m-text-medium">Tanggal Update</span>
                  </a-col>
                  <a-col class="m-text-center" :span="2">
                    <span>:</span>
                  </a-col>
                  <a-col :span="12">
                    <span>{{item.tgl_update}}</span>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="10">
                    <span class="m-text-medium">Tanggal Cuti</span>
                  </a-col>
                  <a-col class="m-text-center" :span="2">
                    <span>:</span>
                  </a-col>
                  <a-col :span="12">
                    <span>{{item.tgl_cuti ? item.tgl_cuti : '-'}}</span>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
          </a-card>
        </a-list-item-meta>
      </a-list-item>
    </a-list>
    <a-modal v-if="!isMobile" :maskClosable="false" v-model="isEdit">
      <template slot="footer">
        <a-button key="back" @click="handleClose">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="btnLoading" @click="handleCutiOk">Submit</a-button>
      </template>

      <div slot="title">Perubahan Jatah Cuti Karyawan</div>
      <a-form :form="form">
        <a-form-item class="m-remove" label="Sisa Cuti">
          <a-input read-only v-decorator="['sisa_cuti', {initialValue: data.sisa_cuti} ]" />
        </a-form-item>
        <a-form-item class="m-remove" label="Penambahan / Pengurangan Cuti">
          <a-input-number
            v-decorator="[
            'rubah_cuti',
            {initialValue: 0,
              rules: [{ required: true, message: 'Penambahan / Pengurangan Cuti Tidak Boleh Kosong' }],
            },
          ]"
            :min="-30"
            :max="30"
          />
        </a-form-item>
        <a-form-item class="m-remove" label="Deskripsi">
          <a-input
            v-decorator="[
            'deskripsi',
            {
              rules: [{ required: true, message: 'Deskripsi Tidak Boleh Kosong' }],
            },
          ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-drawer
      v-else
      :height="350"
      title="Perubahan Jatah Cuti KaryawanX"
      placement="bottom"
      :closable="false"
      @close="handleClose"
      :visible="isEdit"
    >
      <a-form :form="form">
        <a-form-item class="m-remove" label="Sisa Cuti">
          <a-input read-only v-decorator="['sisa_cuti', {initialValue: data.sisa_cuti} ]" />
        </a-form-item>
        <a-form-item class="m-remove" label="Penambahan / Pengurangan Cuti">
          <a-input-number
            v-decorator="[
            'rubah_cuti',
            {initialValue: 0,
              rules: [{ required: true, message: 'Penambahan / Pengurangan Cuti Tidak Boleh Kosong' }],
            },
          ]"
            :min="-30"
            :max="30"
          />
        </a-form-item>
        <a-form-item class="m-remove" label="Deskripsi">
          <a-input
            v-decorator="[
            'deskripsi',
            {
              rules: [{ required: true, message: 'Deskripsi Tidak Boleh Kosong' }],
            },
          ]"
          />
        </a-form-item>
      </a-form>
      <div
        :style="{
          position: 'absolute',
          left: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
        }"
      >
        <a-button @click="handleCutiOk" type="primary">Submit</a-button>
      </div>
    </a-drawer>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";

export default {
  name: "cuti",
  props: ["data"],
  data() {
    return {
      isEdit: false,
      btnLoading: false,
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters(["getAuth", "getDefaultDateFormat"]),
  },
  methods: {
    moment,
    handleCuti() {
      this.isEdit = true;
    },
    handleClose() {
      this.form.resetFields();
      this.isEdit = false;
    },
    handleCutiOk() {
      this.form.validateFields((err, values) => {
        let post = new FormData();
        this.btnLoading = true;
        post.append("tlc_karyawan", this.data.profile.tlc);
        post.append("user_update", this.getAuth.username);
        post.append("jumlah_cuti", values.rubah_cuti);
        post.append("deskripsi", values.deskripsi);

        axios({
          method: "post",
          url: this.$serviceUrl + "master_karyawan/edit_cuti",
          processData: false,
          data: post,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.isEdit = false;
            this.btnLoading = false;
            Event.$emit("fetching");
            this.form.resetFields();
          })
          .catch((err) => {
            console.log(err);
            this.isEdit = false;
          });
      });
    },
    replcBr(item) {
      return item.replace("<br/>", "");
    },
    handleManifest(item) {
      this.$router.push({ name: "manifestCuti", params: { id: item.id_cuti } });
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  font-size: 1rem;
}
</style>